const LAYOUT_MODE = {
  public: 'public',
  protected: 'protected'
} as const;

export { LAYOUT_MODE };
